
class Address {
    constructor(street, city, latitude, longitude, postalCode) {
        this.street = street;
        this.city = city;
        this.latitude = latitude;
        this.longitude = longitude;
        this.postalCode = postalCode;
    }

    static fromJson(json) {
        return new Address(
            json.street,
            json.city,
            json.latitude,
            json.longitude,
            json.postalCode
        );
    }
}
export default Address;
// Create an Event instance from JSON
//   const eventFromJson = Event.fromJson(jsonData);
